import ExcelDownComponent from "@/pcomponents/common/excel/down";
import { useRef,forwardRef,useImperativeHandle } from 'react';
import strFunc from '@/lib/lyg/string';

const SupplyListExcelDown = forwardRef((props:any, ref) => {
   let myProps={
    infoArr:[],
    xColumnArr: {},
    ...props
  };
  const xColumnArr = myProps.xColumnArr;
  const ExcelDownComponentRef = useRef<any>();
  let infoArr = myProps.infoArr;

  useImperativeHandle(ref, () => ({
    // 부모 컴포넌트에서 사용할 함수를 선언
    goExcelDown
  }))

  const goExcelDown = (inData:any) => {
    let opt_obj={
      infoArr:infoArr,
      xColumnArr: xColumnArr,
      ...inData
    };
    let tmp_xColumnArr:any = {...opt_obj.xColumnArr};
    //except_key_arr
    let except_key_arr = ["row_view_pay_btn","row_view_payt_btn","row_view_payt_url","row_view_payt_phone","row_view_manage"];
    let tmp_x_column_list_arr=[...tmp_xColumnArr.x_column_list_arr];
    tmp_x_column_list_arr = tmp_x_column_list_arr.filter((item:any) => {
      return !except_key_arr.includes(item.key);
    });
    tmp_xColumnArr.x_column_list_arr = tmp_x_column_list_arr;
    
    let tmp_info_arr = [...opt_obj.infoArr];
    if (ExcelDownComponentRef.current) {
      for (let i = 0; i < tmp_info_arr.length; i++) {
        let info = tmp_info_arr[i];
        let sum_money = parseInt(strFunc.uncomma(info.a_money_sum));
        let pay_money = parseInt(strFunc.uncomma(info.a_pay_money));
        let unpaid_money = strFunc.comma(sum_money - pay_money);
        info["row_view_unpaid"]=unpaid_money;
      }
      ExcelDownComponentRef.current.setInitData({
        infoArr: tmp_info_arr,
        is_add_example:false,
        xColumnArr: tmp_xColumnArr,
      });
      setTimeout(() => {
        ExcelDownComponentRef.current.goDownExcel();
      }, 100);
    }
  };
  
  return (
  <>
    <ExcelDownComponent
        ref={ExcelDownComponentRef}
        xColumnArr={xColumnArr}
        is_add_example={false}
      ></ExcelDownComponent>
  </>
  );
});
export default SupplyListExcelDown;